import TagManager from 'react-gtm-module';
import { DataLayer } from './types';

export const pushDataLayer = (dataLayerEvent: DataLayer) => {
  const dataLayer = {
    dataLayer: dataLayerEvent,
  };

  TagManager.dataLayer(dataLayer);
};

export const pushSelectFaq = (category: string, title: string) => {
  pushDataLayer({
    event: 'select_content',
    content_group: 'Preguntas frecuentes',
    content_type: category,
    item_id: title
  });
};

export const pushFaqPageView = (userId: string) => {
  pushDataLayer({
    event: 'track_content_group',
    content_group: 'Preguntas frecuentes',
    user_id_custom: userId
  });
};
